import { LinkLikeComponentProps } from "@shopify/polaris/build/ts/latest/src/utilities/link/types"
import React from "react"
import { Link as ReactRouterLink } from "react-router-dom"

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export default function Link({
  children,
  url = "",
  external,
  ref,
  ...rest
}: LinkLikeComponentProps) {
  if (external) {
    rest.target = "_blank"
    rest.rel = "noopener noreferrer"
    return (
      <a href={url} {...rest}>
        {children}
      </a>
    )
  }

  return (
    <ReactRouterLink to={url} {...rest}>
      {/* @ts-ignore*/}
      {children}
    </ReactRouterLink>
  )
}
